export default __webpack_public_path__ + "static/media/superstaff_video.d83b81c3.mp4";